import axios from "axios";
import { environment } from "../../environments/environment";

const API_BASE_NAME = `${environment.apiBaseUrl}`;

// ✅ Types
export interface BankType {
  id?: number;
  name: string;
  mobileNumber: string;
  bankName: string;
  accountNumber: string;
  ifscCode: string;
  status: "ACTIVE" | "INACTIVE";
  createdAt?: string;
  updatedAt?: string;
}

// ✅ Get All Banks
export const getAllBanksApi = async (): Promise<{
  success: boolean;
  data: BankType[];
}> => {
  try {
    const response = await axios.get(`${API_BASE_NAME}/bank/all`);
    return response.data;
  } catch (error) {
    console.error("Error fetching banks:", error);
    throw error;
  }
};

// ✅ Get Active Bank
export const getActiveBankApi = async (): Promise<{
  success: boolean;
  data: BankType[];
}> => {
  try {
    const response = await axios.get(`${API_BASE_NAME}/bank/active`);
    return response.data;
  } catch (error) {
    console.error("Error fetching active bank:", error);
    throw error;
  }
};

// ✅ Create Bank
export const createBankApi = async (data: BankType) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API_BASE_NAME}/bank/create`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating bank:", error);
    throw error;
  }
};

// ✅ Update Bank
export const updateBankApi = async (id: number, data: BankType) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.put(
      `${API_BASE_NAME}/bank/update/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating bank:", error);
    throw error;
  }
};

// ✅ Delete Bank
export const deleteBankApi = async (id: number) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.delete(
      `${API_BASE_NAME}/bank/delete/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting bank:", error);
    throw error;
  }
};

// ✅ Get Bank By ID
export const getBankByIdApi = async (id: number): Promise<{
  success: boolean;
  data: BankType;
}> => {
  try {
    const response = await axios.get(`${API_BASE_NAME}/bank/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bank:", error);
    throw error;
  }
};

// ✅ Update Bank Status Only
export const updateBankStatusApi = async (
  id: number,
  status: "ACTIVE" | "INACTIVE"
) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.patch(
      `${API_BASE_NAME}/bank/status/${id}`,
      { status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating bank status:", error);
    throw error;
  }
};